export default [
  {
    path: '/goods-details',
    name: 'goods-details',
    meta: {
      index: 3
    },
    component: () =>
      import(/* webpackChunkName: "商品详情页" */ '@/pages/goods-details/index.vue')
  },
  {
    path: '/goods-message',
    name: 'goods-message',
    meta: {
      index: 6
    },
    component: () =>
      import(/* webpackChunkName: "商品详情页" */ '@/pages/goods-details/goods-message.vue')
  },
  {
    path: '/gift-detail',
    name: 'gift-detail',
    meta: {
      index: 6
    },
    component: () =>
      import(/* webpackChunkName: "商品详情页" */ '@/pages/goods-details/gift-detail.vue')
  }
]
